import { Pipe } from '@angular/core';
import * as moment from "moment";

@Pipe({
  name: 'UtcToLocalTime'
})
export class UTCtoLocalPipe {
  transform(val: any): any {
    if (val) {
      try {
        const date = moment.utc(val).format();
        const local = moment.utc(date).local().format();
        return local.toString();
      }
      catch (e) {
        return val;
      }
    }  
  }
}


